import React, { useEffect, useRef, useState } from "react";
import FooterCss from "./style";

const Footer = () => {
  const paraRef = useRef();
  const [visible, setVisible] = useState(false);
  const observer = React.useRef(
    new IntersectionObserver(
      (enteries, ob) => {
        enteries.forEach(entry => {
          if (entry.isIntersecting) setVisible(true);
        });
      },
      { root: null, rootMargin: "-200px 0px", threshold: 0 }
    )
  );
  useEffect(() => {
    observer.current.observe(paraRef.current);
  }, []);

  let classes = "title";
  if (visible) {
    classes += " fadeIn";
  }
  return (
    <FooterCss>
      <div className="wrapper">
        <div className={classes} ref={paraRef}>
          Plant Your Seed
        </div>
        <div className="icons" id="footer">
          <div className="foot">
            <a
              className="footer_link"
              href="mailto:cefa@crystalelephant.net"
              target="_blank"
              rel="noreferrer"
            >
              <img src="footer/email.png" alt="email" />
            </a>
            <p>Email</p>
          </div>
          <div className="foot">
            <a
              href="https://twitter.com/CEFAToken"
              target="_blank"
              rel="noreferrer"
            >
              <img src="footer/twitter.png" alt="twitter" />
            </a>
            <p>Twitter</p>
          </div>
          <div className="foot">
            <a
              href="https://www.youtube.com/playlist?list=PLfb8Qomp_Dd-9WD2tLcjNV3jGp2ncpUV0"
              target="_blank"
              rel="noreferrer"
            >
              <img src="footer/youtube.png" alt="youtube" />
            </a>
            <p>Youtube</p>
          </div>
          <div className="foot">
            <a
              href="https://discord.gg/Qek3eMeHDk"
              target="_blank"
              rel="noreferrer"
            >
              <img src="footer/discord.png" alt="discord" />
            </a>
            <p>Discord</p>
          </div>
          <div className="foot">
            <a
              href="https://www.reddit.com/r/CrystalElephantToken/"
              target="_blank"
              rel="noreferrer"
            >
              <img src="footer/reddit.png" alt="reddit" />
            </a>
            <p>Reddit</p>
          </div>
          <div className="foot">
            <a
              href="https://t.me/CEFAOfficial"
              target="_blank"
              rel="noreferrer"
            >
              <img src="footer/telegram.png" alt="telegram" />
            </a>
            <p>Telegram</p>
          </div>
        </div>
      </div>
    </FooterCss>
  );
};

export default Footer;
